import { createContext, ReactElement, ReactNode, useMemo } from "react";

import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";

const EncounterDateContext = createContext<{ encounterDate: Date, encounterDateTimeWithPrecision: DateTimeWithPrecision } | null>(null);

interface EncounterDateContextProviderProps {
    encounterDate: Date;
    children: ReactNode;
}

function EncounterDateContextProvider({ encounterDate, children }: Readonly<EncounterDateContextProviderProps>): ReactElement {
    const encounterValue = useMemo(() => ({
        encounterDate,
        encounterDateTimeWithPrecision: DateTimeWithPrecision.getDate(encounterDate)
    }), [encounterDate]);

    return (
        <EncounterDateContext.Provider value={encounterValue}>
            {children}
        </EncounterDateContext.Provider>
    );
}

export {
    EncounterDateContext,
    EncounterDateContextProvider
};
